<template>
    <v-autocomplete
      ref="select"
      :items="options"
      v-model="proxyValue"
      item-text="title"
      item-value="id"
      :rules="rules"
      no-data-text="No client"
      label="Please, select client"
      small-chips
      clearable
    >
      <template
        slot="selection"
        slot-scope="props"
      >
        <v-chip
          class="chip--select-multi v-chip--small"
        >
          <v-tooltip bottom>
            <span slot="activator">{{ props.item.shortTitle | NoEmpty}}</span>
            <span>{{ props.item.title | NoEmpty}}</span>
          </v-tooltip>
        </v-chip>
      </template>
    </v-autocomplete>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import NoEmpty from "../../Filters/NoEmpty";

    export default {
        name: 'client-select',
        props: {
            value: {
                type: String,
            },
            rules: {
                type: Array,
                default() {
                    return []
                }
            },
        },
        filters: {
            NoEmpty
        },
        data() {
            return {}
        },
        mounted() {
            this.fetchInitDataIfRequired()
        },
        computed: {
            ...mapState({
                availableClients: 'availableClients',
                costCenters: 'costCenters'
            }),
            proxyValue: {
                get() {
                    return this.value
                },
                set(newValue) {
                    console.log('set(newValue) is: ', newValue);
                    this.$emit('selected', newValue)
                }
            },
            options() {
                const clients = this.availableClients.map(client => {
                    return {
                        ...client,
                        id: 'CL' + client.id,
                        shortTitle: client.title.trim().substring(0, 50)
                    }
                })
                const costCenters = this.costCenters.map(center => {
                    return {
                        ...center,
                        id: 'CC' + center.id,
                        shortTitle: center.title.trim().substring(0, 50)
                    }
                })
                return [...costCenters, ...clients]
            }
        },
        methods: {
            ...mapActions({
                fetchInitDataIfRequired: 'fetchInitDataIfRequired'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/ClientSelect.vue